<div class="app-container" appButtonController>
  <app-volume></app-volume>
  <app-channel-widget></app-channel-widget>
  <router-outlet></router-outlet>
  <app-loader></app-loader>
</div>
